import styled, { css } from "styled-components";
import { getPaddingStyle, getMarginStyle } from "core/styles/paddingMarginStyle";
import { BreadcrumbProps, ItemProps } from "./";

export const Container = styled.nav<BreadcrumbProps>`
  .breadcrumb-item:not(:first-child) {
    :before {
      content: "";
      width: 16px;
      height: 16px;
      background: ${({ icon }) => `url(${icon})`};
      background-position: center center;
      background-repeat: no-repeat;
    }
  }

  ${getMarginStyle}
  ${getPaddingStyle}
`;

export const BreadcrumbList = styled.ol`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 0px;
  margin-bottom: 0px;
`;

const breadcrumbActiveStyle = ({ active }: { active?: boolean }) =>
  active &&
  css`
    a {
      cursor: default;
      background-color: ${({ theme }) => theme?.colors?.neutral.neutral30};
    }
  `;

export const BreadcrumbItem = styled.li<ItemProps>`
  display: flex;
  align-items: center;
  gap: 8px;

  a {
    padding: 4px 16px;
    border-radius: 8px;
    gap: 8px;
    max-width: ${({ itemWidth }) => itemWidth};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: ${({ theme }) => theme?.colors?.white};
    border: 1px solid ${({ theme }) => theme?.colors?.neutral.neutral40};
    color: ${({ theme }) => theme?.colors?.neutral.neutral100};
    cursor: pointer;
    font-family: Nunito-Sans-Bold;
  }

  ${getMarginStyle}
  ${getPaddingStyle}
  ${breadcrumbActiveStyle}
`;
